import { Slide } from "@jelly/lesson";
import { task as task03 } from "../../../../../task/course-03/lesson-16/task-03";

const task: Slide = {
  titleHtml: `What are features of headphone equalisation?`,
  descriptionHtml: "Select the correct answer(s).",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task03.id,
        },
      },
    },
  },
};

export default task;
